import React from 'react'
import PropTypes from 'prop-types'

import { Image, Text } from 'Components/UI'

import { Container, PhotoHolder, TextHolder } from './styles'

function TestimonialSlide({ data = {} }) {
  return (
    <Container>
      <PhotoHolder mr={[0, 0, 13]}>
        <Image
          alt={data?.fullName ? `Photo of ${data.fullName}` : ''}
          height="100%"
          image={data?.image}
          layout="responsive"
          lazy
          sizes="(max-width: 992px) 90vw, 340px"
          width="100%"
        />
      </PhotoHolder>

      <TextHolder mb="1px" mr="1px">
        <Text as="h3" fontSize={[20, 20, 32]} mb={1} medium>
          {data?.fullName}
        </Text>

        <Text fontSize={[14, 14, 16, 16, 20]} light mb={3}>
          {data?.positionHeld}
        </Text>

        <Text fontSize={[14, 14, 16, 16, 20]} light>
          {data?.text}
        </Text>
      </TextHolder>
    </Container>
  )
}

TestimonialSlide.propTypes = {
  data: PropTypes.object,
}

export default TestimonialSlide
